import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../authConfig';

interface LoginButtonProps {
    className?: string;
}

const LoginButton: React.FC<LoginButtonProps> = ({ className = 'btn' }) => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [checking, setChecking] = useState(false);

    const handleLogin = async () => {
        if (checking) return;
        setChecking(true);

        try {
            const accounts = instance.getAllAccounts();

            if (accounts.length > 0) {
                // Existing session — try silent token refresh
                try {
                    await instance.acquireTokenSilent({
                        ...loginRequest,
                        account: accounts[0],
                    });
                    // Token valid — go straight to the app
                    navigate('/add');
                    return;
                } catch {
                    // Token refresh failed — need fresh login
                }
            }

            // No session or refresh failed — go to custom login page
            navigate('/auth/login');
        } catch {
            navigate('/auth/login');
        } finally {
            setChecking(false);
        }
    };

    return (
        <button
            onClick={handleLogin}
            className={className}
            style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '16px',
                padding: '16px 32px',
                fontSize: '18px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 8px 24px rgba(102, 126, 234, 0.3)',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'center',
                minWidth: '200px',
                margin: '0 auto'
            }}
            onMouseEnter={(e) => {
                const target = e.target as HTMLButtonElement;
                target.style.transform = 'translateY(-2px)';
                target.style.boxShadow = '0 12px 32px rgba(102, 126, 234, 0.4)';
            }}
            onMouseLeave={(e) => {
                const target = e.target as HTMLButtonElement;
                target.style.transform = 'translateY(0px)';
                target.style.boxShadow = '0 8px 24px rgba(102, 126, 234, 0.3)';
            }}
        >
            {checking ? '⏳ Overujem...' : '🔐 Prihlásiť sa'}
        </button>
    );
};

export default LoginButton;